import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const attendanceApi = createApi({
    reducerPath: 'attendanceApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client/attendance",
    }),
    endpoints: (builder) => ({

        // add attendance
        addAttendance: builder.mutation({
            query: ({ therapistId, data }) => ({
                method: "POST",
                url: `/${therapistId}`,
                data
            }),
        }),

        // update attendance
        updateAttendance: builder.mutation({
            query: ({ attendanceId, attendance, session_date }) => ({
                method: "PUT",
                url: `/${attendanceId}`,
                data: { session_date, attendance }
            }),
        }),

        // delete attendance
        deleteAttendance: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `/${id}`
            }),
        }),
    }),
})

export const {
    useAddAttendanceMutation,
    useUpdateAttendanceMutation,
    useDeleteAttendanceMutation

} = attendanceApi;